<template>
  <v-dialog v-model="val" max-width="400" overlay-opacity="1">
    <v-card>
      <v-card-title>
        <h4 class="text-h4">Orden Ingresada!</h4>
      </v-card-title>
      <v-card-text class="text-center">
        <v-icon size="120" color="green">check_circle</v-icon>
      </v-card-text>
      <v-card-text>
        Tu orden está ingresada, vas a recibir un email con el resumen.
      </v-card-text>
      <v-card-text class="text-center">
        <v-btn color="indigo white--text" @click="$emit('confirmed')">Seguir orden</v-btn>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CustomerOrderConfirmedModal",
  props: {
    value: {type: Boolean, default: false},
    timeout: {type: Number}
  },
  data() {
    return {
      open: true
    }
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    if(this.timeout){
      this.closeOnTimeout()
    }
  },
  methods: {
    closeOnTimeout() {
      setTimeout(() => this.val = false,this.timeout)
    }
  }
}
</script>

<style scoped>

</style>
